export default __webpack_public_path__ + "static/media/bg5.d60a95eb.jpg";